import { useEffect, useState } from "react";
import { useDebounce } from "src/utils/hooks/useDebounce";
import { Css } from "~generated/css";
import { useTestIds } from "~utils";
import { Icon } from "./Icon";
import { TextField } from "./TextField";

type SearchBarProps = {
  onSearch(filter: string): void;
  fullWidth?: boolean;
  placeholder?: string;
  debounceDelayInMs?: number;
};

export function SearchBar(props: SearchBarProps) {
  const { onSearch, fullWidth, debounceDelayInMs, placeholder = "Search" } = props;

  const [value, setValue] = useState<string>("");
  const debouncedValue = useDebounce(value, debounceDelayInMs);
  const tid = useTestIds(props, "searchBox");

  useEffect(() => {
    onSearch(debouncedValue);
  }, [debouncedValue, onSearch]);

  return (
    <div css={fullWidth ? Css.w100.$ : Css.wPx(244).$}>
      <TextField
        value={value}
        type="search"
        onChange={(e, v) => setValue(v ?? "")}
        placeholder={placeholder}
        startAdornment={<Icon name="search" />}
        cssOverrides={Css.bgGray100.br16.bshNone.plPx(40).pr2.$}
        {...tid}
      />
    </div>
  );
}
